"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewalCoveragesTree = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var ExtraCoversTree_1 = require("../ExtraCoversTree");
var ValuableItemTree_1 = require("../ValuableItemTree");
var HomeWarrantiesTree_1 = require("../HomeWarrantiesTree");
var HomeRenewalCoversTree_1 = require("./HomeRenewalCoversTree");
var Tree_1 = require("../../../components/Tree");
var RenewalCoveragesTree = /** @class */ (function (_super) {
    __extends(RenewalCoveragesTree, _super);
    function RenewalCoveragesTree(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    RenewalCoveragesTree.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(Tree_1.Tree, { label: "Coverages", children: [(0, jsx_runtime_1.jsx)(HomeRenewalCoversTree_1.HomeRenewalCoversTree, { interaction: this.props.interaction }), (0, jsx_runtime_1.jsx)(ExtraCoversTree_1.default, { interaction: this.props.interaction }), (0, jsx_runtime_1.jsx)(ValuableItemTree_1.default, { interaction: this.props.interaction }), (0, jsx_runtime_1.jsx)(HomeWarrantiesTree_1.default, { interaction: this.props.interaction })] }));
    };
    return RenewalCoveragesTree;
}(React.Component));
exports.RenewalCoveragesTree = RenewalCoveragesTree;
//# sourceMappingURL=RenewalCoveragesTree.js.map